
import { mapState, mapGetters } from 'vuex'
import createCryptoWithdrawalForm from '~/mixins/common/finance/create-crypto-withdrawal-form'
import withdrawalMinMaxAmountRule from '~/mixins/common/finance/withdrawal-min-max-amount-rule'
export default {
    mixins: [withdrawalMinMaxAmountRule, createCryptoWithdrawalForm],
    props: {
        steppers: {
            type: Number,
            default: 1,
        },
        resultData: {
            type: Object,
            default: () => {},
        },
        isWithdrawalSuccessful: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            existLoading: false,
            formCryptoValid: false,
        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.themes.withdraw.loading,
            player: (state) => state.player.player,
            cryptoCurrencyList: (state) =>
                state.settings.cryptoWalletAddressList,
            playerCryptoWallets: (state) =>
                state.themes['player-bank'].playerCryptoWallets,
            exchangeRateLoading: (state) =>
                state.themes.settings.exchangeRateLoading,
        }),
        ...mapGetters({
            bankAccount: 'themes/player-bank/bankAccount',
            swapAllExchangeRate: 'themes/settings/swapAllExchangeRate',
            getCurrencyColor: 'finance/getCurrencyColor',
            getCurrencySymbol: 'finance/getCurrencySymbol',
        }),
        playerCurrencyCookie() {
            return this.$cookie.get('player')?.currency
        },
        withdrawalAmountErrorMessages() {
            const amount = parseFloat(
                this.withdrawalForm?.amount?.replaceAll(',', '')
            )
            if (!amount) {
                return null
            }
            if (amount > this.playerRealtimeBalance()) {
                return `${this.tl('balanceInsufficient')}`
            }
            if (amount < this.withdrawalMinAndMaxAmount.min) {
                return `${this.tl('minimumWithdrawIs')} ${this.formatCurrencyJS(
                    this.withdrawalMinAndMaxAmount.min
                )}`
            }
            if (amount > this.withdrawalMinAndMaxAmount.max) {
                return `${this.tl('maximumWithdrawIs')} ${this.formatCurrencyJS(
                    this.withdrawalMinAndMaxAmount.max
                )}`
            }
            if (
                !this.decimalRule(
                    this.withdrawalForm.amount?.replaceAll(',', '')
                )
            ) {
                return this.tl('decimalIsTwoDigit')
            }
            return null
        },
    },
    methods: {
        async onCreateCryptoWithdrawal() {
            if (!this.$refs.cryptoForm.validate()) return null
            const response = await this.$store.dispatch(
                'themes/withdraw/createCryptoWithdrawal',
                {
                    amount: this.withdrawalForm.amount,
                    player_crypto_wallet_id:
                        this.withdrawalForm.player_crypto_wallet_id,
                }
            )
            if (response) {
                this.$emit('onCreateCryptoWithdrawal', response)
            }
        },
        async cancelPending(item) {
            const confirm = window.confirm(this.tl('uSureToCancel?'))
            if (!confirm) return
            const result = await this.$store.dispatch(
                'themes/withdraw/cancelWithdraw',
                item.id
            )
            if (result) {
                this.$emit('cancelPending', result)
            }
        },
    },
}
